import React from "react"

function TextBanner(props) {
  return (
    <section id="banner">
      <div className="inner">
        {
          props.h1 ? (
            <div className="banner_header">
              <span>
                <h1>{props.h1}</h1>
              </span>
            </div>
          ) : null
        }

        {
          props.quote ? (
            <p><strong><i>{props.quote}</i></strong></p>
          ) : null
        }

      </div>
    </section>
  )
}

export default TextBanner